import { createTheme, MantineProvider } from '@mantine/core';
import { Vendor } from '@models/response/vendor';
import React from 'react';

const ThemeProvider = ({ children, vendor }: { children: React.ReactNode; vendor: Vendor }) => {
  const theme = createTheme({
    fontFamily: 'dana',
    defaultRadius: 'md',
    colors: {
      cyan: [
        '#f0fafa',
        '#e2f2f2',
        '#bee5e3',
        '#99d8d5',
        '#7bccc9',
        '#69c4c1',
        '#5cc2bd',
        '#4daaa6',
        '#00afaa',
        '#2a8480',
      ],

      brand: [
        '#e7e5e4',
        '#d6d3d1',
        '#a8a29e',
        '#78716c',
        '#57534e',
        '#44403c',
        '#292524',
        '#1c1917',
        '#0c0a09',
        '#0c0a09',
      ],
    },

    white: 'white',
    primaryColor: vendor?.themeVendor?.color || 'brand',
  });
  return (
    <MantineProvider theme={theme} forceColorScheme="light">
      {children}
    </MantineProvider>
  );
};

export default ThemeProvider;
